/* Label & Leaf header v2 — predictive search, mini-basket, favourites,
   mega menu, full-screen mobile menu. No dependencies. */
(function () {
  /* Idempotence: the layout loads this script, and a stale live copy of the
     header section can load it a second time. Binding twice would attach the
     document-level favourites/heart click handler twice, so every heart tap
     would toggle the product on and straight back off. */
  if (window.__llHeaderV2) return;
  window.__llHeaderV2 = true;

  var root = document.getElementById('llp-header');
  if (!root) return;

  /* Minor units → the shopper's own currency. ll-money.js loads first in
     theme.liquid; the bare amount is only a defensive fallback. */
  var money = function (cents) {
    return window.LLMoney ? window.LLMoney.format(cents) : (cents / 100).toFixed(2);
  };

  /* Which storefront this page is: 'GB' or 'US'. Favourites record it so a
     saved product is never priced or linked in the wrong market. */
  var llRegion = root.getAttribute('data-ll-region') || '';

  var escapeHtml = function (value) {
    var entities = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return entities[character];
    });
  };

  /* ---------- promo rotation ---------- */
  var promo = root.querySelector('[data-llp-promo]');
  if (promo) {
    var msgs = (promo.getAttribute('data-llp-promo') || '').split('||').filter(Boolean);
    var textEl = promo.querySelector('[data-llp-promo-text]');
    var pi = 0;
    var show = function (n) {
      pi = (n + msgs.length) % msgs.length;
      textEl.textContent = msgs[pi];
    };
    var prev = promo.querySelector('[data-llp-promo-prev]');
    var next = promo.querySelector('[data-llp-promo-next]');
    if (msgs.length < 2) {
      if (prev) prev.style.visibility = 'hidden';
      if (next) next.style.visibility = 'hidden';
    } else {
      prev.addEventListener('click', function () { show(pi - 1); });
      next.addEventListener('click', function () { show(pi + 1); });
    }
  }

  /* ---------- helpers: open/close overlays with a scrim ---------- */
  function overlay(el) {
    /* A tap on the overlay element itself that lands outside its box —
       the phone menu's dimmed page strip is drawn by a fixed pseudo-
       element beyond the panel's right edge — closes it. Taps inside the
       box (the panel's own padding) and on descendants do nothing here. */
    if (el) {
      el.addEventListener('click', function (e) {
        if (e.target !== el) return;
        var box = el.getBoundingClientRect();
        if (e.clientX >= box.right || e.clientX < box.left) api.close();
      });
    }
    var api = {
      el: el,
      open: function () {
        if (!el) return;
        el.hidden = false;
        requestAnimationFrame(function () { el.classList.add('is-open'); });
        document.body.style.overflow = 'hidden';
      },
      close: function () {
        if (!el) return;
        el.classList.remove('is-open');
        document.body.style.overflow = '';
        setTimeout(function () { el.hidden = true; }, 250);
      },
      isOpen: function () { return el && !el.hidden; }
    };
    return api;
  }

  /* ---------- mobile menu panel ---------- */
  var mmenu = overlay(root.querySelector('[data-llp-menu]'));
  root.querySelectorAll('[data-llp-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      mmenu.open();
      if (btn.hasAttribute('data-llp-menu-search')) {
        setTimeout(function () {
          var inp = root.querySelector('[data-llp-menu-search-input]');
          if (inp) inp.focus();
        }, 260);
      }
    });
  });
  root.querySelectorAll('[data-llp-menu-close]').forEach(function (el) {
    el.addEventListener('click', function () { mmenu.close(); });
  });

  /* ---------- predictive search (desktop inline) ---------- */
  var searchForm = root.querySelector('[data-llp-search]');
  if (searchForm) {
    var input = searchForm.querySelector('[data-llp-search-input]');
    var panel = searchForm.querySelector('[data-llp-search-panel]');
    var results = searchForm.querySelector('[data-llp-search-results]');
    var allLink = searchForm.querySelector('[data-llp-search-all]');
    var clearBtn = searchForm.querySelector('[data-llp-search-clear]');
    var timer = null;
    var lastQuery = '';

    var closePanel = function () { panel.hidden = true; };
    var openPanel = function () { panel.hidden = false; };

    var fetchResults = function (q) {
      /* The JSON suggest API is unavailable on this shop, so we render a
         minimal theme section (ll-predictive) through the Section
         Rendering API and inject its markup. */
      fetch('/search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&section_id=ll-predictive')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (q !== input.value.trim()) return; // stale response
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var frag = doc.querySelector('[data-llp-suggest]');
          var count = frag ? parseInt(frag.getAttribute('data-count'), 10) || 0 : 0;
          if (!frag || count === 0) {
            results.innerHTML = '<p class="llp-search__none">No matches for &ldquo;' +
              q.replace(/[<>&"]/g, '') + '&rdquo;</p>';
          } else {
            results.innerHTML = frag.innerHTML;
          }
          allLink.href = '/search?type=product,page,article&q=' + encodeURIComponent(q);
          openPanel();
        })
        .catch(function () { closePanel(); });
    };

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearBtn.hidden = q.length === 0;
      clearTimeout(timer);
      if (q.length < 2) { closePanel(); lastQuery = ''; return; }
      timer = setTimeout(function () {
        if (q === lastQuery) { openPanel(); return; }
        lastQuery = q;
        fetchResults(q);
      }, 220);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && results.innerHTML) openPanel();
    });
    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.hidden = true;
      closePanel();
      input.focus();
    });
    document.addEventListener('click', function (e) {
      if (!searchForm.contains(e.target)) closePanel();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closePanel(); input.blur(); }
    });
  }

  /* ---------- basket: click opens cart drawer, hover shows mini-basket ---------- */
  var basket = root.querySelector('[data-llp-basket]');
  if (basket) {
    var basketBtn = basket.querySelector('[data-llp-basket-open]');
    var pop = basket.querySelector('[data-llp-basket-pop]');
    var popItems = basket.querySelector('[data-llp-basket-pop-items]');
    var popSubtotal = basket.querySelector('[data-llp-basket-pop-subtotal]');
    var countEl = basket.querySelector('[data-llp-cart-count]');
    var hoverTimer = null;
    var cartStale = true;

    /* The count changes without a page load, so the accessible name has to be
       re-written every time rather than baked in at render. */
    var basketWord = basketBtn.getAttribute('data-llp-basket-label') ||
      (llRegion === 'US' ? 'Cart' : 'Basket');
    var setCount = function (n) {
      if (countEl) {
        countEl.textContent = n;
        countEl.hidden = n === 0;
      }
      basketBtn.setAttribute('aria-label', basketWord + ' (' + n + (n === 1 ? ' item' : ' items') + ')');
    };

    var openDrawer = function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        window.location.href = '/cart';
      }
    };
    basketBtn.addEventListener('click', function () {
      if (pop) pop.hidden = true;
      openDrawer();
    });

    var renderPop = function (cart) {
      if (!cart.items.length) {
        var llBasketWord = llRegion === 'US' ? 'cart' : 'basket';
        popItems.innerHTML = '<p class="llp-basket__pop-empty">Your ' + llBasketWord + ' is empty</p>';
        popSubtotal.textContent = '';
        return;
      }
      popItems.innerHTML = cart.items.slice(0, 4).map(function (it) {
        /* Match the basket and cart drawer: a saved editor proof is the
           authoritative image for a personalised line item. Catalogue media
           is only a fallback for products without a saved proof. */
        var personalisedArtwork = it.properties && it.properties['_Personalised artwork'];
        var imageUrl = personalisedArtwork || it.image;
        var thumbnailUrl = personalisedArtwork
          ? imageUrl
          : imageUrl && imageUrl.replace(/(\.[a-z]{3,4})(\?|$)/, '_120x$1$2');
        var img = thumbnailUrl
          ? '<img src="' + escapeHtml(thumbnailUrl) + '" alt="" width="48" height="60" loading="lazy">'
          : '';
        return '<div class="llp-basket__pop-item">' +
          '<span class="llp-basket__pop-thumb">' + img + '</span>' +
          '<span class="llp-basket__pop-body"><span class="llp-basket__pop-title">' + escapeHtml(it.product_title) + '</span>' +
          '<span class="llp-basket__pop-meta">Qty ' + it.quantity + ' &middot; ' + money(it.final_line_price) + '</span></span>' +
          '</div>';
      }).join('') + (cart.items.length > 4
        ? '<p class="llp-basket__pop-more">+ ' + (cart.items.length - 4) + ' more</p>' : '');
      popSubtotal.textContent = 'Subtotal ' + money(cart.items_subtotal_price);
    };

    var refreshPop = function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cartStale = false;
          renderPop(cart);
          setCount(cart.item_count);
        })
        .catch(function () {});
    };

    if (pop && window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
      basket.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () {
          if (cartStale) refreshPop();
          pop.hidden = false;
        }, 120);
      });
      basket.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { pop.hidden = true; }, 180);
      });
    }

    /* Dawn's cart JS re-renders the hidden #cart-icon-bubble decoy after any
       cart change — mirror its count into our badge and refetch the popover. */
    var decoy = document.getElementById('cart-icon-bubble');
    if (decoy) {
      new MutationObserver(function () {
        var bubble = decoy.querySelector('.cart-count-bubble span[aria-hidden]');
        var n = bubble ? parseInt(bubble.textContent, 10) || 0 : 0;
        setCount(n);
        cartStale = true;
      }).observe(decoy, { childList: true, subtree: true });
    }
  }

  /* ---------- favourites (localStorage wishlist) ---------- */
  var FAVS_KEY = 'll:favourites';
  var favs = {
    read: function () {
      try { return JSON.parse(localStorage.getItem(FAVS_KEY)) || []; } catch (e) { return []; }
    },
    write: function (list) {
      try { localStorage.setItem(FAVS_KEY, JSON.stringify(list)); } catch (e) {}
      favs.sync();
    },
    has: function (handle) {
      return favs.read().some(function (f) { return f.handle === handle; });
    },
    toggle: function (item) {
      var list = favs.read();
      var i = list.findIndex(function (f) { return f.handle === item.handle; });
      if (i >= 0) { list.splice(i, 1); } else { list.push(item); }
      favs.write(list);
      return i < 0;
    },
    sync: function () {
      var list = favs.read();
      var badge = root.querySelector('[data-llp-favs-count]');
      if (badge) {
        badge.textContent = list.length;
        badge.hidden = list.length === 0;
      }
      renderFavsList();
      document.querySelectorAll('[data-llp-fav-toggle]').forEach(function (btn) {
        var on = favs.has(btn.getAttribute('data-handle'));
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
  };
  window.llpFavourites = favs;

  var favsOverlay = overlay(root.querySelector('[data-llp-favs]'));
  var favsList = root.querySelector('[data-llp-favs-list]');
  var favsEmpty = root.querySelector('[data-llp-favs-empty]');

  /* handle → 'pending' | product JSON | 'gone' | null (ask again). Re-opening
     the sidebar reuses what this page view already learned. */
  var favsLooked = {};

  function renderFavsList() {
    if (!favsList) return;
    var list = favs.read();
    favsList.querySelectorAll('.llp-aside__item').forEach(function (n) { n.remove(); });
    if (favsEmpty) favsEmpty.hidden = list.length > 0;
    list.forEach(function (f) {
      var row = document.createElement('div');
      row.className = 'llp-aside__item';
      row.setAttribute('data-llp-fav-row', f.handle || '');
      /* Everything here came out of localStorage, which any script on the
         page can write — escape every field before it becomes markup. */
      row.innerHTML =
        '<a class="llp-aside__item-thumb' + (f.book ? ' llp-aside__item-thumb--book' : '') +
          '" href="' + escapeHtml(f.url) + '" data-llp-fav-link>' +
          (f.image ? '<img src="' + escapeHtml(f.image) + '" alt="" width="72" height="90" loading="lazy">' : '') +
        '</a>' +
        '<div class="llp-aside__item-body">' +
          '<a class="llp-aside__item-title" href="' + escapeHtml(f.url) + '" data-llp-fav-link>' + escapeHtml(f.title) + '</a>' +
          '<p class="llp-aside__item-price" data-llp-fav-price hidden></p>' +
          '<div class="llp-aside__item-links">' +
            '<a href="' + escapeHtml(f.url) + '" data-llp-fav-link data-llp-fav-view>View</a>' +
            '<button type="button" data-llp-fav-remove="' + escapeHtml(f.handle) + '">Remove</button>' +
          '</div>' +
        '</div>';
      favsList.appendChild(row);
    });
    if (favsOverlay && favsOverlay.isOpen()) hydrateFavsList();
  }

  /* Prices and product URLs belong to the storefront the shopper is on, not
     to the market the favourite was saved in — ask this storefront for them.
     A product the current market does not sell answers 404. */
  /* UK and US sell market twins of every book under paired handles: the US
     handle is bare, the UK handle carries -uk. A favourite saved on one store
     and opened on the other must resolve to this store's twin, not to a 404. */
  function favouriteTwinHandle(handle) {
    if (!handle) return '';
    return /-uk$/.test(handle) ? handle.replace(/-uk$/, '') : handle + '-uk';
  }

  function hydrateFavsList() {
    if (!favsList) return;
    favsList.querySelectorAll('[data-llp-fav-row]').forEach(function (row) {
      var handle = row.getAttribute('data-llp-fav-row');
      if (!handle) return;
      var known = favsLooked[handle];
      if (known === 'pending') return;
      if (known) { paintFavRow(handle, known); return; }
      favsLooked[handle] = 'pending';
      var lookup = function (candidate) {
        return fetch('/products/' + encodeURIComponent(candidate) + '.js', { headers: { Accept: 'application/json' } });
      };
      lookup(handle)
        .then(function (r) {
          if (r.status === 404) {
            var twin = favouriteTwinHandle(handle);
            if (!twin || twin === handle) return 'gone';
            return lookup(twin).then(function (tr) {
              if (tr.status === 404) return 'gone';
              if (!tr.ok) return null;
              return tr.json();
            });
          }
          if (!r.ok) return null;
          return r.json();
        })
        .then(function (product) {
          /* A transport failure stays unknown rather than "unavailable" — a
             favourite is not lost because one request dropped. */
          favsLooked[handle] = product || null;
          if (product) paintFavRow(handle, product);
        })
        .catch(function () { favsLooked[handle] = null; });
    });
  }

  /* Rows are rebuilt whenever the list changes, so paint by handle rather than
     into whichever element was on screen when the request went out. */
  function productAvailableInThisCountry(product) {
    var countryNode = document.querySelector('[data-ll-country]');
    var country = (countryNode ? countryNode.getAttribute('data-ll-country') : '') || llRegion;
    country = country.toUpperCase();
    /* The shopper's range (ll-region-code): GB for every country that buys the
       UK edition, so an Australian shopper keeps their UK-edition favourites. */
    var edition = (llRegion || country).toUpperCase();
    var tags = Array.isArray(product && product.tags) ? product.tags.map(function (tag) { return String(tag).toLowerCase(); }) : [];
    var handle = product && product.handle || '';
    var type = String(product && (product.type || product.product_type) || '').toLowerCase();
    var isWallArt = type.indexOf('wall art') !== -1 || type.indexOf('poster') !== -1 || type.indexOf('art print') !== -1 || type.indexOf('natal chart') !== -1 || type.indexOf('astrocartography') !== -1 || tags.indexOf('wall-art') !== -1 || tags.indexOf('wall art') !== -1 || handle.indexOf('astrocartography-chart') !== -1 || handle.indexOf('natal-chart') !== -1;
    var isUkEdition = /-uk$/.test(handle) || tags.indexOf('region:gb') !== -1 || tags.indexOf('market: uk') !== -1 || tags.indexOf('uk wall art') !== -1;
    var isUsEdition = tags.indexOf('region:us') !== -1 || tags.indexOf('market: us') !== -1;
    var hasGlobal = tags.indexOf('availability:global') !== -1;
    var isDigital = tags.indexOf('delivery:digital') !== -1 || /-digital$/.test(handle);
    if (hasGlobal && isDigital && !isUkEdition && !isUsEdition) return true;
    if (hasGlobal || isDigital) return false;
    if (isWallArt) return country === 'US' && !isUkEdition && !isUsEdition;
    if (isUkEdition && isUsEdition) return false;
    var destination = isUkEdition ? 'GB' : 'US';
    return destination === edition;
  }

  function paintFavRow(handle, product) {
    if (!favsList) return;
    if (product && product !== 'gone' && !productAvailableInThisCountry(product)) product = 'gone';
    favsList.querySelectorAll('[data-llp-fav-row]').forEach(function (row) {
      if (row.getAttribute('data-llp-fav-row') !== handle) return;
      var priceEl = row.querySelector('[data-llp-fav-price]');
      if (product === 'gone') {
        var view = row.querySelector('[data-llp-fav-view]');
        if (view) view.remove();
        row.querySelectorAll('[data-llp-fav-link]').forEach(function (link) {
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
        });
        if (priceEl) {
          priceEl.textContent = 'Not available in your storefront';
          priceEl.hidden = false;
        }
        return;
      }
      if (priceEl) {
        priceEl.textContent = money(product.price);
        priceEl.hidden = false;
      }
      if (product.url) {
        row.querySelectorAll('[data-llp-fav-link]').forEach(function (a) {
          a.setAttribute('href', product.url);
        });
      }
      // Saved colouring-book and bundle thumbnails can predate a media fix.
      // Keep storybook/editorial image overrides for other product families.
      var tags = Array.isArray(product.tags) ? product.tags : [];
      if (tags.indexOf('coloring-book') !== -1 || tags.indexOf('Book bundle') !== -1) {
        var currentImage = product.featured_image || (product.images && product.images[0]);
        var thumbnail = row.querySelector('.llp-aside__item-thumb img');
        if (thumbnail && typeof currentImage === 'string' && /^(https?:\/\/|\/\/)/.test(currentImage)) {
          thumbnail.src = currentImage;
        }
      }
    });
  }
  if (favsList) {
    favsList.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-llp-fav-remove]');
      if (rm) {
        favs.write(favs.read().filter(function (f) { return f.handle !== rm.getAttribute('data-llp-fav-remove'); }));
      }
    });
  }
  document.querySelectorAll('[data-llp-favs-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      favsOverlay.open();
      hydrateFavsList();
    });
  });
  root.querySelectorAll('[data-llp-favs-close]').forEach(function (el) {
    el.addEventListener('click', function () { favsOverlay.close(); });
  });

  /* heart toggles anywhere on the page */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-llp-fav-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    /* No price is stored: it belongs to one market and one moment. Hearts
       rendered before the market attribute existed fall back to this page's
       region. */
    favs.toggle({
      handle: btn.getAttribute('data-handle'),
      market: btn.getAttribute('data-market') || llRegion,
      title: btn.getAttribute('data-title'),
      url: btn.getAttribute('data-url'),
      image: btn.getAttribute('data-image'),
      book: btn.hasAttribute('data-book')
    });
  });

  /* ---------- mega menu: keyboard + touch support ---------- */
  root.querySelectorAll('[data-llp-mega]').forEach(function (item) {
    var link = item.querySelector('.llp-nav__link');
    var firstTap = false;
    var closeTimer;
    var openMenu = function () {
      clearTimeout(closeTimer);
      item.classList.remove('is-dismissed');
      item.classList.add('is-open');
      link.setAttribute('aria-expanded', 'true');
    };
    var closeMenu = function () {
      clearTimeout(closeTimer);
      item.classList.remove('is-open');
      link.setAttribute('aria-expanded', item.contains(document.activeElement) ? 'true' : 'false');
    };
    link.addEventListener('touchend', function (e) {
      if (!firstTap) {
        e.preventDefault();
        firstTap = true;
        openMenu();
        setTimeout(function () { firstTap = false; }, 3000);
      }
    });
    item.addEventListener('click', function (event) {
      if (!event.target.closest('.llp-mega__grid--books a')) return;
      clearTimeout(closeTimer);
      item.classList.remove('is-open');
      item.classList.add('is-dismissed');
      link.setAttribute('aria-expanded', 'false');
    });
    item.addEventListener('mouseenter', openMenu);
    item.addEventListener('mouseleave', function () {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMenu, 300);
    });
    item.addEventListener('focusin', function () {
      clearTimeout(closeTimer);
      item.classList.remove('is-dismissed');
      link.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget) && !item.matches(':hover')) closeMenu();
    });
  });

  /* ---------- global escape key ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    [mmenu, favsOverlay].forEach(function (o) { if (o.isOpen()) o.close(); });
  });

  favs.sync();
})();

/* ---------- product-card colour and design swatches (collection / search / carousel) ---------- */
(function () {
  function paintAuto() {
    document.querySelectorAll('[data-llp-card-swatch][data-llp-autocolour]').forEach(function (b) {
      var name = b.getAttribute('data-llp-autocolour');
      var hash = 0;
      for (var i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) % 360;
      b.style.background = 'hsl(' + hash + ', 32%, 58%)';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAuto);
  } else {
    paintAuto();
  }

  var WIDTHS = [300, 400, 600, 800, 1000, 1200];
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-llp-card-swatch]');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    var card = sw.closest('.llp-pcard');
    if (!card) return;

    card.querySelectorAll('[data-llp-card-swatch]').forEach(function (b) {
      var on = b === sw;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var base = sw.getAttribute('data-image');
    var img = card.querySelector('.llp-pcard__tile img');
    if (img && base) {
      img.removeAttribute('srcset');
      img.src = base;
      if (base.indexOf('width=1200') !== -1) {
        img.srcset = WIDTHS.map(function (w) {
          return base.replace('width=1200', 'width=' + w) + ' ' + w + 'w';
        }).join(', ');
      }
      var name = card.querySelector('.llp-pcard__name');
      img.alt = (name ? name.textContent.trim() : '') + ' – ' + (sw.getAttribute('data-colour') || '');
    }

    var vid = sw.getAttribute('data-variant');
    var design = sw.getAttribute('data-design');
    if (vid || design) {
      var href = new URL(card.getAttribute('href'), window.location.href);
      if (vid) href.searchParams.set('variant', vid);
      if (design) href.searchParams.set('design', design);
      card.setAttribute('href', href.pathname + href.search + href.hash);
    }

    var fav = card.querySelector('[data-llp-fav-toggle]');
    if (fav) {
      if (base) fav.setAttribute('data-image', base.replace('width=1200', 'width=200'));
      if (vid || design) fav.setAttribute('data-url', card.getAttribute('href'));
    }
  });
})();

/* Sign-in options: Google + email only. "Sign in with shop" cannot be
   disabled in admin without turning off Shop Pay, so remove the slotted
   <shop-login> element from the account popover's (open) shadow tree.
   The component upgrades (and attaches its shadow root) after this
   script runs, and the login form itself loads lazily when the sheet
   opens — so poll for the shadow root, then keep observing. */
(function () {
  function strip(root) {
    try {
      root.querySelectorAll('shop-login').forEach(function (n) { n.remove(); });
    } catch (e) { /* Shopify internals changed — leave the button alone */ }
  }
  function watch(acc) {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      var sr = acc.shadowRoot;
      if (sr) {
        window.clearInterval(timer);
        strip(sr);
        try {
          new MutationObserver(function () { strip(sr); })
            .observe(sr, { childList: true, subtree: true });
        } catch (e) { /* no observer — initial strip already ran */ }
      } else if (tries > 50) {
        window.clearInterval(timer); // component never initialised; give up
      }
    }, 200);
  }
  document.querySelectorAll('shopify-account').forEach(watch);
})();

/* ---------- the child's photo on basket thumbnails (this device only) ----------
   ll-books-offers.js rememberBasketPhotoCover keeps, in this browser only, a
   copy of a book line's cover with the child's photo in their spot; the cover
   uploaded with the line stays photo-free (owner, 2026-10-19). The basket
   page, the cart drawer and the header popover swap that copy in for its
   line, and copies whose line has left the basket are forgotten. Without the
   copy (another device, cleared storage) the uploaded cover shows as before. */
(function () {
  'use strict';
  var STORE = 'll:basket-photo-covers';
  var MAX_AGE = 14 * 24 * 60 * 60 * 1000;
  // A copy made seconds ago may belong to a basket add still in flight.
  var FRESH = 10 * 60 * 1000;
  var storage = null;
  try { storage = window.localStorage; } catch (e) { storage = null; }
  if (!storage || !window.crypto || !window.crypto.subtle || typeof TextEncoder === 'undefined' || !window.fetch) return;

  function read() {
    try {
      var stored = JSON.parse(storage.getItem(STORE) || '{}');
      return stored && typeof stored === 'object' && !Array.isArray(stored) ? stored : {};
    } catch (e) { return {}; }
  }
  // The same source and hash as ll-books-offers.js basketPhotoCoverKey.
  function source(p) {
    p = p || {};
    var single = p['_Customer photo'] && p['_Story ID'];
    var story = single ? p['_Story ID'] : p['_Book 1 story ID'];
    var ref = single ? p['_Customer photo'] : (p['_Book 1 photo'] || p['_Book 1 photo ref']);
    return typeof story === 'string' && typeof ref === 'string' && story && /^ll-photo:v1:/.test(ref) ? 'v1|' + story + '|' + ref : '';
  }
  function key(p) {
    var s = source(p);
    if (!s) return Promise.resolve('');
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(s)).then(function (hash) {
      return Array.prototype.map.call(new Uint8Array(hash), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('').slice(0, 32);
    }, function () { return ''; });
  }
  function swap(img, src) {
    if (!img || img.getAttribute('src') === src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
    img.setAttribute('data-ll-photo-cover', '');
  }
  var quote = function (value) { return window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/"/g, '\\"'); };

  var running = false, again = false;
  function apply() {
    if (running) { again = true; return Promise.resolve(); }
    var stored = read();
    if (!Object.keys(stored).length) return Promise.resolve();
    running = true;
    return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var items = (cart && cart.items) || [];
      return Promise.all(items.map(function (it) { return key(it.properties); })).then(function (keys) {
        var now = Date.now(), live = {}, changed = false;
        keys.forEach(function (k) { if (k) live[k] = true; });
        Object.keys(stored).forEach(function (k) {
          var age = now - ((stored[k] && stored[k].t) || 0);
          if (age > MAX_AGE || (!live[k] && age > FRESH)) { delete stored[k]; changed = true; }
        });
        if (changed) { try { storage.setItem(STORE, JSON.stringify(stored)); } catch (e) { /* keep showing */ } }
        var popRows = document.querySelectorAll('[data-llp-basket-pop-items] .llp-basket__pop-item');
        items.forEach(function (it, i) {
          var hit = keys[i] && stored[keys[i]];
          if (!hit || typeof hit.src !== 'string' || hit.src.indexOf('data:image/jpeg;base64,') !== 0) return;
          swap(document.querySelector('.llb-item[data-key="' + quote(it.key) + '"] .llb-item__img img'), hit.src);
          var row = document.getElementById('CartDrawer-Item-' + (i + 1));
          if (row && row.getAttribute('data-handle') === it.handle) swap(row.querySelector('img.cart-item__image'), hit.src);
          if (popRows[i]) swap(popRows[i].querySelector('.llp-basket__pop-thumb img'), hit.src);
        });
      });
    }).catch(function () {}).then(function () {
      running = false;
      if (again) { again = false; apply(); }
    });
  }

  // The basket page and drawer re-render their rows after a change; the popover redraws on hover.
  var timer = null;
  function soon() { clearTimeout(timer); timer = setTimeout(apply, 120); }
  function watch() {
    ['#llb', 'cart-drawer', '[data-llp-basket-pop-items]'].forEach(function (selector) {
      var node = document.querySelector(selector);
      if (node && window.MutationObserver) new MutationObserver(soon).observe(node, { childList: true, subtree: true });
    });
    apply();
  }
  window.LLBasketPhotoCovers = { key: key, apply: apply };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
}());

/* ---------- expired browser copies of the child's photo go (RET-09) ----------
   DPIA v0.21, Annex P.24.7 control 1 (owner, 2026-10-28). ll-books-offers.js
   keeps the chosen photo and name in this browser's IndexedDB
   (`ll-books-handoff`, store `child`): `shopping-child`, restorable in its tab
   for 1 hour after its last write (createChildSessionStore), and the bundle
   hand-over `current`, usable for 15 minutes (HANDOFF_TTL_MS). The product
   pages delete them only when one is next opened; this sweep, on every page,
   deletes either once it is past its window. A record still inside its
   window is never touched, and the read and the delete share one transaction,
   so a page that rewrites a record meanwhile keeps it. It waits for the page
   to load and the browser to be idle, does nothing without IndexedDB, never
   creates the database (a first visit aborts the open) and never throws. */
(function () {
  'use strict';
  var DB = 'll-books-handoff';
  var STORE = 'child';
  var WINDOWS = { 'shopping-child': 60 * 60 * 1000, current: 15 * 60 * 1000 };
  var idb = null;
  try { idb = window.indexedDB || null; } catch (e) { idb = null; }
  if (!idb || window.__llBrowserCopySweep) return;
  window.__llBrowserCopySweep = true;

  // Past its window, or no time it could be restored by: neither reader would
  // ever use it (validHandoff, createChildSessionStore's load).
  function expired(record, windowMs, now) {
    var at = record && typeof record === 'object' ? Number(record.at) : NaN;
    return !isFinite(at) || now - at >= windowMs;
  }

  // Resolves with the keys it deleted; never rejects.
  function sweep(now) {
    now = now == null ? Date.now() : now;
    return new Promise(function (resolve) {
      var removed = [], request;
      try { request = idb.open(DB); } catch (e) { resolve(removed); return; }
      // No database yet: nothing to sweep, and none is made.
      request.onupgradeneeded = function () { try { request.transaction.abort(); } catch (e) { /* the open fails below */ } };
      request.onblocked = function () { resolve(removed); };
      request.onerror = function (event) { if (event && event.preventDefault) event.preventDefault(); resolve(removed); };
      request.onsuccess = function () {
        var db = request.result;
        function done(keys) { try { db.close(); } catch (e) { /* closed */ } resolve(keys); }
        try {
          if (!db.objectStoreNames.contains(STORE)) { done(removed); return; }
          var tx = db.transaction(STORE, 'readwrite'), store = tx.objectStore(STORE);
          Object.keys(WINDOWS).forEach(function (key) {
            var read = store.get(key);
            read.onsuccess = function () {
              if (read.result === undefined || !expired(read.result, WINDOWS[key], now)) return;
              store.delete(key); removed.push(key);
            };
          });
          tx.oncomplete = function () { done(removed); };
          tx.onerror = tx.onabort = function (event) { if (event && event.preventDefault) event.preventDefault(); done([]); };
        } catch (e) { done([]); }
      };
    }).catch(function () { return []; });
  }
  window.LLBrowserCopies = { sweep: sweep, expired: expired, windows: WINDOWS };

  function idle() {
    if (window.requestIdleCallback) window.requestIdleCallback(function () { sweep(); }, { timeout: 5000 });
    else window.setTimeout(function () { sweep(); }, 1500);
  }
  try {
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle);
  } catch (e) { /* no sweep on this page */ }
}());
